import { ColDef, ValueFormatterParams } from 'ag-grid-enterprise';

import { getObfuscatedSourceType } from '../helpers/source-type.helpers';
import { ActionCellRenderer } from './market-mapping.table-renderers';

export const columnDefs = [
  {
    field: 'sourceType',
    headerName: 'SOURCE',
    valueFormatter: (params: ValueFormatterParams) => getObfuscatedSourceType(params.value),
    flex: 1,
  },
  {
    field: 'companiesCount',
    headerName: 'COMPANIES',
    flex: 8,
  },
  {
    field: 'actions',
    headerName: 'ACTIONS',
    cellRenderer: ActionCellRenderer,
    width: 100,
    maxWidth: 100,
    resizable: false,
    suppressSizeToFit: true,
  },
] as ColDef<any, any>[];
